module.exports = __webpack_public_path__ + "static/image/history/pc/202605_1.ver2_0_2.jpg?bbc314e5";